import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Chip, CircularProgress, Stack, Typography } from '@mui/material';
import { capitalize } from 'lodash';
import { RoleEnum } from '~/api/types';
import { useGetDatasetAffectedProjectsQuery } from '~/api/v2/hooks';
import { loadingContainerStyles } from '~/pages/ProjectDetailsPage/components/styles';

interface AffectedProjectsPanelProps {
  userId: string;
}

const AffectedProjectsPanel: FC<AffectedProjectsPanelProps> = ({ userId }) => {
  const datasetId = +useParams().id!;
  const { data, isFetching } = useGetDatasetAffectedProjectsQuery({ datasetId, userId });

  if (isFetching) {
    return (
      <Box sx={{ ...loadingContainerStyles, minHeight: '160px' }}>
        <CircularProgress size={70} sx={{ color: '#1010eb' }} />
      </Box>
    );
  }

  if (!data?.length) return null;

  return (
    <Box p={3} sx={{ borderRadius: 2, border: '1px solid #0000001A' }}>
      <Stack spacing={3}>
        <Typography variant="bodyDefaultStrong">Affected Projects:</Typography>
        {data?.map(({ project_id, project_name, role_id }) => (
          <Stack key={project_id} justifyContent="space-between" direction="row">
            <Typography variant="bodyDefault">{project_name}</Typography>
            <Chip size="small" label={<Typography>{capitalize(RoleEnum[role_id])}</Typography>} />
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};

export default AffectedProjectsPanel;
